import React, { useMemo } from 'react'
import {
  UI_COMPONENT_CATEGORIES,
  UI_COMPONENT_REGISTRY,
  UI_FOUNDATION_REGISTRY,
  type UiComponentCategory,
  type UiComponentEntry,
  type UiFoundationEntry,
} from '../uiRegistry'

type UiComponentSidebarProps = {
  selectedId: string
  onSelect: (id: string) => void
}

const UiComponentSidebar: React.FC<UiComponentSidebarProps> = ({
  selectedId,
  onSelect,
}) => {
  const componentsByCategory = useMemo(
    () =>
      UI_COMPONENT_CATEGORIES.map((category) => ({
        category,
        items: UI_COMPONENT_REGISTRY.filter(
          (item) => item.category === category,
        ),
      })).filter((group) => group.items.length > 0),
    [],
  )

  const renderItem = (
    item: UiFoundationEntry | UiComponentEntry,
  ): React.ReactNode => (
    <li key={item.id}>
      <button
        type="button"
        className={`ui-sidebar__item${
          selectedId === item.id ? ' ui-sidebar__item--active' : ''
        }`}
        onClick={() => onSelect(item.id)}
      >
        {item.label}
      </button>
    </li>
  )

  const renderCategoryGroup = (
    category: UiComponentCategory,
    items: UiComponentEntry[],
  ): React.ReactNode => (
    <div key={category} className="ui-sidebar__group">
      <p className="ui-sidebar__section-label">{category}</p>
      <ul className="ui-sidebar__list">{items.map(renderItem)}</ul>
    </div>
  )

  return (
    <aside className="ui-sidebar">
      <div className="ui-sidebar__header">
        <h1 className="ui-sidebar__title">EnamelAI DS</h1>
        <p className="ui-sidebar__subtitle">@enamelai/design-system</p>
      </div>

      <nav className="ui-sidebar__nav" aria-label="UI components">
        <ul className="ui-sidebar__list">
          {UI_FOUNDATION_REGISTRY.map(renderItem)}
        </ul>

        <div className="ui-sidebar__divider" aria-hidden="true" />

        {componentsByCategory.map(({ category, items }) =>
          renderCategoryGroup(category, items),
        )}
      </nav>
    </aside>
  )
}

export default UiComponentSidebar
